// Export the rat body parts as three arrays. 
import ratHead1 from "./ratHeads/rathead.png";
import ratHead2 from "./ratHeads/rathead2.png";
import ratHead3 from "./ratHeads/ratfemmehead1.png";
import ratHead4 from "./ratHeads/rathead4.png";
import ratHead5 from "./ratHeads/rathead5.png";
import ratHead6 from "./ratHeads/rathead6.png";
import ratHead7 from "./ratHeads/rathead7.png";
import ratHead8 from "./ratHeads/rathead8.png";
import ratHead9 from "./ratHeads/rathead9.png";
import ratBody1 from "./ratBody/ratbody.png";
import ratBody2 from "./ratBody/ratbodytshirt.png";
import ratBody3 from "./ratBody/ratfemmemiddle1.png";
import ratBody4 from "./ratBody/ratbody4.png";
import ratBody5 from "./ratBody/ratbody5.png";
import ratBody6 from "./ratBody/ratbody6.png";
import ratBody7 from "./ratBody/ratbody7.png";
import ratBody8 from "./ratBody/ratbody8.png";
import ratBody9 from "./ratBody/ratbody9.png";
import ratBum1 from "./ratBum/ratbum1.png";
import ratBum2 from "./ratBum/ratbum2.png";
import ratBum3 from "./ratBum/ratfemmebum1.png";
import ratBum4 from "./ratBum/ratbum4.png";
import ratBum5 from "./ratBum/ratbum5.png";
import ratBum6 from "./ratBum/ratbum6.png";
import ratBum7 from "./ratBum/ratbum7.png";
import ratBum8 from "./ratBum/ratbum8.png";
import ratBum9 from "./ratBum/ratbum9.png";

const headArray = [
  ratHead1,
  ratHead2,
  ratHead4,
  ratHead3,
  ratHead5,
  ratHead6,
  ratHead7,
  ratHead8,
  ratHead9,
];

const bodyArray = [
  ratBody1,
  ratBody2,
  ratBody4,
  ratBody3,
  ratBody5,
  ratBody6,
  ratBody7,
  ratBody8,
  ratBody9,
];

const bumArray = [
  ratBum1,
  ratBum2,
  ratBum4,
  ratBum3,
  ratBum5,
  ratBum6,
  ratBum7,
  ratBum8,
  ratBum9,
];

export { bumArray, headArray, bodyArray };